import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

const errorSchema = z.object({ message: z.string() });

export const globalSearchThreadResultSchema = z.object({
  id: z.string().min(1),
  title: z.string(),
  href: z.string().min(1),
  author_display_name: z.string().nullable(),
  author_handle: z.string().nullable(),
});

export const globalSearchSkillResultSchema = z.object({
  name: z.string().min(1),
  usage_count: z.number().int().nonnegative(),
  href: z.string().min(1),
});

export const globalSearchPersonResultSchema = z.object({
  id: z.string().min(1),
  display_name: z.string(),
  handle: z.string().nullable(),
  avatar_url: z.string().nullable(),
  href: z.string().min(1),
});

export const globalSearchResponseSchema = z.object({
  type: z.literal('global_search'),
  threads: z.array(globalSearchThreadResultSchema),
  skills: z.array(globalSearchSkillResultSchema),
  people: z.array(globalSearchPersonResultSchema),
});

export const globalSearchQuerySchema = z.object({
  q: z.string().trim().min(1).max(80),
});

export const searchContract = c.router({
  globalSearch: {
    method: 'GET',
    path: '/search',
    headers: z.object({
      authorization: z.string().min(1).optional(),
    }),
    query: globalSearchQuerySchema,
    responses: {
      200: globalSearchResponseSchema,
      401: errorSchema,
      422: errorSchema,
    },
    summary:
      'Global navbar search. Threads and people are searched globally (subject to thread visibility); skills are scoped to the viewer workspace. Max 5 results per kind.',
  },
});

export type GlobalSearchThreadResult = z.infer<typeof globalSearchThreadResultSchema>;
export type GlobalSearchSkillResult = z.infer<typeof globalSearchSkillResultSchema>;
export type GlobalSearchPersonResult = z.infer<typeof globalSearchPersonResultSchema>;
export type GlobalSearchResponse = z.infer<typeof globalSearchResponseSchema>;
export type GlobalSearchQuery = z.infer<typeof globalSearchQuerySchema>;
